export default __webpack_public_path__ + "static/media/icon_number_yellow_1.ca805b91.svg";